import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Camera } from "lucide-react";

const STATUS_COLORS = {
  draft: "bg-slate-200 text-slate-900",
  quoted: "bg-blue-100 text-blue-900",
  invoiced: "bg-amber-100 text-amber-900",
  paid: "bg-emerald-100 text-emerald-900",
  completed: "bg-emerald-100 text-emerald-900",
  cancelled: "bg-red-100 text-red-900",
};

export default function EstimatesList() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/estimates").then((r) => setItems(r.data)); }, []);
  return (
    <div className="p-4 md:p-8 max-w-6xl mx-auto">
      <div className="flex items-end justify-between mb-6">
        <div>
          <p className="text-xs uppercase tracking-widest text-primary mb-1">Pipeline</p>
          <h1 className="font-display text-4xl font-black tracking-tight">Estimates</h1>
        </div>
        <Link to="/app/new-estimate"><Button className="h-11 rounded-sm btn-kinetic"><Camera className="w-4 h-4 mr-1" /> New</Button></Link>
      </div>
      {items.length === 0 ? (
        <div className="bento-card p-12 text-center">
          <Camera className="w-10 h-10 text-primary mx-auto mb-4" />
          <p className="text-muted-foreground mb-4">No estimates yet. Snap your first property photo.</p>
          <Link to="/app/new-estimate"><Button className="rounded-sm">Create estimate</Button></Link>
        </div>
      ) : (
        <div className="bento-card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-muted text-left">
              <tr>
                <th className="px-4 py-3 font-medium">Niche</th>
                <th className="px-4 py-3 font-medium hidden md:table-cell">Address</th>
                <th className="px-4 py-3 font-medium">Status</th>
                <th className="px-4 py-3 font-medium hidden md:table-cell">Created</th>
                <th className="px-4 py-3 font-medium text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              {items.map((e, idx) => (
                <tr key={e.id} className={`border-t border-border ${idx % 2 ? "bg-muted/40" : ""}`}>
                  <td className="px-4 py-3">
                    <Link to={`/app/estimates/${e.id}`} data-testid={`est-row-${e.id}`} className="text-primary font-medium capitalize hover:underline">{e.niche.replace(/_/g, " ")}</Link>
                  </td>
                  <td className="px-4 py-3 hidden md:table-cell text-muted-foreground">{e.address || "—"}</td>
                  <td className="px-4 py-3"><Badge className={STATUS_COLORS[e.status]}>{e.status}</Badge></td>
                  <td className="px-4 py-3 hidden md:table-cell text-muted-foreground">{new Date(e.created_at).toLocaleDateString()}</td>
                  <td className="px-4 py-3 font-mono font-semibold text-right">${e.total?.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
